export const ADMIN_DASHBOARD_TRANSLATION_NAMESPACE = "monitoring-dashboard";

export const ADMIN_DASHBOARD_TK = "ADMIN_DASHBOARD_TK";
